import { Component, Inject, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { DynamicFormService } from '../../../shared/components/dynamic-forms-components/dynamic-form.service';
import { FieldConfig, FieldType } from '../../../shared/components/dynamic-forms-components/field.interface';
import { ProcessType, WorkFlow, WorkflowDtoInput } from '../../../store/entities/epaper-management/epaper.model';
import { CREATE_WORK_FLOW_MUTATION } from '../../../store/entities/epaper-management/epaper.graphql';
import { StoreItemActions } from '../../../store/entities/store-item/store-item.actions';
import { StoreItemEntity } from '../../../store/entities/store-item/store-item.model';
import { AppState } from '../../../store';

@Component({
  selector: 'app-create-update-workflow',
  templateUrl: './create-update-workflow.component.html',
  styleUrls: ['./create-update-workflow.component.scss']
})
export class CreateUpdateWorkflowComponent implements OnInit {
  private dynamicFormService: DynamicFormService = inject(DynamicFormService);
  private fb = inject(UntypedFormBuilder);
  private store = inject(Store<AppState>);

  title: string;
  loading = false;
  form: UntypedFormGroup;
  fields: FieldConfig[];

  workflow: WorkFlow;

  processTypes = Object.values(ProcessType); // 🔥 Correct enum values

  constructor(
    private dialogRef: MatDialogRef<CreateUpdateWorkflowComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.workflow = data?.workflow;
  }

  ngOnInit(): void {
    this.title = this.workflow ? 'Edit Workflow' : 'Create Workflow';

    this.form = this.fb.group({
      name: [this.workflow?.name || '', Validators.required],
      processType: [this.workflow?.processType || '', Validators.required]
      // ❌ stages removed — backend does NOT accept it
    });

    this.fields = this.formFields();
  }

  formFields(): FieldConfig[] {
    return [
      {
        type: FieldType.input,
        label: 'Workflow Name',
        key: 'name',
        validations: [
          { name: 'required', validator: Validators.required, message: 'Workflow Name is required' }
        ],
        rowClass: 'col-span-12'
      },
      {
        type: FieldType.select,
        label: 'Process Type',
        key: 'processType',
        options: this.processTypes.map(pt => ({
          name: pt,
          value: pt
        })),
        validations: [
          { name: 'required', validator: Validators.required, message: 'Process Type is required' }
        ],
        rowClass: 'col-span-12'
      },
      {
        type: FieldType.button,
        label: 'Save',
        rowClass: 'col-span-12'
      }
    ];
  }

  submitForm(formValue: any) {
    if (!this.form.valid) return;

    this.loading = true;

    // ✅ Only send allowed fields
    const formData: WorkflowDtoInput = this.workflow
      ? { uuid: this.workflow.uuid, ...formValue }
      : { ...formValue };

    this.store.dispatch(
      StoreItemActions.createUpdateStoreItem({
        entity: StoreItemEntity.workflow,
        input: formData,
        mutation: CREATE_WORK_FLOW_MUTATION,
        isInput: true
      })
    );

    setTimeout(() => {
      this.loading = false;
      this.closeModal(true);
    }, 300);
  }

  closeModal(refresh: boolean = false) {
    this.dialogRef.close(refresh);
  }
}
